
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexp9ROV1Nng8EuNM9lQnEfCBLym4AqfYjsf4l8WGAohcIMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/begagnat/index.vue?macro=true";
import { default as _91_46_46_46slug_935sGpPkQYDIXYyRPBwBLMf8QCw7_45xOFFW_kurH17CoZ8Meta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/deals/[...slug].vue?macro=true";
import { default as indexDYjNdhhErgz567n_kEY_45li_45yTQILYIN5OZOvWx6F75AMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/familjeabonnemang/index.vue?macro=true";
import { default as indexKM1YWCg3CDcOShaSUoSpZlnINlpSY_sdiFVikdsllI8Meta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/kontantkort/index.vue?macro=true";
import { default as index_45Vn3_cxKeGrdN4eIr5AtqWkcsyr8rWZ_Rgq_45zOjdbOcMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobilabonnemang/index.vue?macro=true";
import { default as _91name_931rufGxb4ZQ5LLDcez9bHelDNeWMMmxJ2fGCDJnHeuCcMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/[manufacturer]/[name].vue?macro=true";
import { default as indexSNCxyLZbGJZbfv9OoimjDD22vfTei_sp6OxN_45mnZcmgMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/[manufacturer]/index.vue?macro=true";
import { default as indexTByi6ys2ooR_Ia9gSFNcpMzMBz4yal_1akUnhREeQvUMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/index.vue?macro=true";
import { default as index_G9u_JzVth9GzW7BedEveHeq3kgk7miJmMevhNP4NSkMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/betalstatus/index.vue?macro=true";
import { default as index6LmIuW0VYx5Eqz4vW5HCH4QPMPGyUz_45KsM9Xks7_458gQMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/byt-in/index.vue?macro=true";
import { default as expressCheckoutwc9u_ASL6DhdlugiJ_QvqOLmDTxh4u7wsx6gpcWO6IoMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/expressCheckout.vue?macro=true";
import { default as _91orderGuid_93zYCr8Eg_45BqYAUojX1swvOkB3BC6ExBfSlMM0n0JsVfIMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/kvitto/[orderGuid].vue?macro=true";
import { default as _91orderId_zipCode_93cVAMTjaYwQL9jwaLuSEkEUNRTiybk6tMmjG_45vnZqpxcMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/min-bestallning/[orderId_zipCode].vue?macro=true";
import { default as _91orderId_939BRmAfI9sgU7nHFPQwWbNUZx1OG6CAYvzXXrRoCy79kMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/orderstatus/[orderId].vue?macro=true";
import { default as indexUlGKfaRYOKdnVBYZIBwO_45LDgnYXyfB2GD2lMKFFMAH4Meta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/orderstatus/index.vue?macro=true";
import { default as _91orderGuid_93pWrvEFc_45gZCUgHDyoIZ7qzioZjD8e_tPSsau8A2le08Meta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/standaloneteliapay/[orderGuid].vue?macro=true";
import { default as indexKRfgu_Yn2t8ZiobL75bfU1phvbQUsTTOomonilSmArAMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/varukorg/index.vue?macro=true";
import { default as indexDLk_45_457dkzmjBMr_45l0KXQdrQU9oqWnPDlY6LJG8iSwEIMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/student/index.vue?macro=true";
import { default as _91name_93M0ylgEdT4_45g_ZtJBQuitBSqv8w_IepAXzAXtG8NRro8Meta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/[manufacturer]/[name].vue?macro=true";
import { default as indext0hidgNgFv7ig9jhcuiTOZKZHN12CtDYrGZFy9nIOXEMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/[manufacturer]/index.vue?macro=true";
import { default as indexEpbUjTxUyeC46JFzw0Y03eU4aUhbxdCXtyk99jPnW4IMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/index.vue?macro=true";
import { default as component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80trykMeta } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80tryk } from "D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "begagnat",
    path: "/begagnat",
    meta: indexp9ROV1Nng8EuNM9lQnEfCBLym4AqfYjsf4l8WGAohcIMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/begagnat/index.vue")
  },
  {
    name: "deals-slug",
    path: "/deals/:slug(.*)*",
    meta: _91_46_46_46slug_935sGpPkQYDIXYyRPBwBLMf8QCw7_45xOFFW_kurH17CoZ8Meta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/deals/[...slug].vue")
  },
  {
    name: "familjeabonnemang",
    path: "/familjeabonnemang",
    meta: indexDYjNdhhErgz567n_kEY_45li_45yTQILYIN5OZOvWx6F75AMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/familjeabonnemang/index.vue")
  },
  {
    name: "kontantkort",
    path: "/kontantkort",
    meta: indexKM1YWCg3CDcOShaSUoSpZlnINlpSY_sdiFVikdsllI8Meta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/kontantkort/index.vue")
  },
  {
    name: "mobilabonnemang",
    path: "/mobilabonnemang",
    meta: index_45Vn3_cxKeGrdN4eIr5AtqWkcsyr8rWZ_Rgq_45zOjdbOcMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobilabonnemang/index.vue")
  },
  {
    name: "mobiltelefoner-manufacturer-name",
    path: "/mobiltelefoner/:manufacturer()/:name()",
    meta: _91name_931rufGxb4ZQ5LLDcez9bHelDNeWMMmxJ2fGCDJnHeuCcMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/[manufacturer]/[name].vue")
  },
  {
    name: "mobiltelefoner-manufacturer",
    path: "/mobiltelefoner/:manufacturer()",
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/[manufacturer]/index.vue")
  },
  {
    name: "mobiltelefoner",
    path: "/mobiltelefoner",
    meta: indexTByi6ys2ooR_Ia9gSFNcpMzMBz4yal_1akUnhREeQvUMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/mobiltelefoner/index.vue")
  },
  {
    name: "shop-betalstatus",
    path: "/shop/betalstatus",
    meta: index_G9u_JzVth9GzW7BedEveHeq3kgk7miJmMevhNP4NSkMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/betalstatus/index.vue")
  },
  {
    name: "shop-byt-in",
    path: "/shop/byt-in",
    meta: index6LmIuW0VYx5Eqz4vW5HCH4QPMPGyUz_45KsM9Xks7_458gQMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/byt-in/index.vue")
  },
  {
    name: "shop-expressCheckout",
    path: "/shop/expressCheckout",
    meta: expressCheckoutwc9u_ASL6DhdlugiJ_QvqOLmDTxh4u7wsx6gpcWO6IoMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/expressCheckout.vue")
  },
  {
    name: "shop-kvitto-orderGuid",
    path: "/shop/kvitto/:orderGuid()",
    meta: _91orderGuid_93zYCr8Eg_45BqYAUojX1swvOkB3BC6ExBfSlMM0n0JsVfIMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/kvitto/[orderGuid].vue")
  },
  {
    name: "shop-min-bestallning-orderId_zipCode",
    path: "/shop/min-bestallning/:orderId_zipCode()",
    meta: _91orderId_zipCode_93cVAMTjaYwQL9jwaLuSEkEUNRTiybk6tMmjG_45vnZqpxcMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/min-bestallning/[orderId_zipCode].vue")
  },
  {
    name: "shop-orderstatus-orderId",
    path: "/shop/orderstatus/:orderId()",
    meta: _91orderId_939BRmAfI9sgU7nHFPQwWbNUZx1OG6CAYvzXXrRoCy79kMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/orderstatus/[orderId].vue")
  },
  {
    name: "shop-orderstatus",
    path: "/shop/orderstatus",
    meta: indexUlGKfaRYOKdnVBYZIBwO_45LDgnYXyfB2GD2lMKFFMAH4Meta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/orderstatus/index.vue")
  },
  {
    name: "shop-standaloneteliapay-orderGuid",
    path: "/shop/standaloneteliapay/:orderGuid()",
    meta: _91orderGuid_93pWrvEFc_45gZCUgHDyoIZ7qzioZjD8e_tPSsau8A2le08Meta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/standaloneteliapay/[orderGuid].vue")
  },
  {
    name: "shop-varukorg",
    path: "/shop/varukorg",
    meta: indexKRfgu_Yn2t8ZiobL75bfU1phvbQUsTTOomonilSmArAMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/shop/varukorg/index.vue")
  },
  {
    name: "student",
    path: "/student",
    meta: indexDLk_45_457dkzmjBMr_45l0KXQdrQU9oqWnPDlY6LJG8iSwEIMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/student/index.vue")
  },
  {
    name: "tillbehor-manufacturer-name",
    path: "/tillbehor/:manufacturer()/:name()",
    meta: _91name_93M0ylgEdT4_45g_ZtJBQuitBSqv8w_IepAXzAXtG8NRro8Meta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/[manufacturer]/[name].vue")
  },
  {
    name: "tillbehor-manufacturer",
    path: "/tillbehor/:manufacturer()",
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/[manufacturer]/index.vue")
  },
  {
    name: "tillbehor",
    path: "/tillbehor",
    meta: indexEpbUjTxUyeC46JFzw0Y03eU4aUhbxdCXtyk99jPnW4IMeta || {},
    component: () => import("D:/TeamCity/buildAgent1/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/pages/tillbehor/index.vue")
  },
  {
    name: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80trykMeta?.name,
    path: "/",
    component: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80tryk
  },
  {
    name: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80trykMeta?.name,
    path: "/abonnemang",
    component: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80tryk
  },
  {
    name: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80trykMeta?.name,
    path: "/shop",
    component: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80tryk
  },
  {
    name: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80trykMeta?.name,
    path: "/shop/kvitto",
    component: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80tryk
  },
  {
    name: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80trykMeta?.name,
    path: "/ladda",
    component: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80tryk
  },
  {
    name: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80trykMeta?.name,
    path: "/shop/min-bestallning",
    component: component_45stubBibGKCTsPKgtZJAeJT7qFAwaW484KroHVavmM80tryk
  }
]